"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ticker = void 0;
const module_abstract_1 = require("@kennethgomez/module/module.abstract");
const event_enum_1 = require("@kennethgomez/events/event.enum");
const events_1 = require("@kennethgomez/events/events");
const animation_ticker_1 = require("./animation/animation-ticker");
class Ticker extends module_abstract_1.Module {
    _tickers;
    constructor() {
        super();
        this._tickers = [
            new animation_ticker_1.AnimationTicker(),
        ];
    }
    onInit() {
        events_1.Events.on(event_enum_1.Event.ADD_TICKER, this._addTicker, this);
    }
    onDispose() {
        for (const ticker of this._tickers) {
            ticker.dispose();
        }
    }
    update(delta) {
        this._tickers = this._tickers.filter((t) => !t.disposed);
        for (const ticker of this._tickers) {
            ticker.update(delta);
        }
    }
    _addTicker(data) {
        if (data) {
            this._tickers.push(data.ticker);
        }
    }
}
exports.Ticker = Ticker;
